import { render, staticRenderFns } from "./AddResourceFileModal.vue?vue&type=template&id=a6e8c522&"
import script from "./AddResourceFileModal.vue?vue&type=script&lang=js&"
export * from "./AddResourceFileModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceFileModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e8c522')) {
      api.createRecord('a6e8c522', component.options)
    } else {
      api.reload('a6e8c522', component.options)
    }
    module.hot.accept("./AddResourceFileModal.vue?vue&type=template&id=a6e8c522&", function () {
      api.rerender('a6e8c522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/AddResourceFileModal.vue"
export default component.exports